import React, { useState } from "react";
import { useSelector } from "react-redux";

import { Link } from "react-router-dom";
import { Button, UncontrolledAlert } from "reactstrap";

import { Card, CardBody, Col, Row } from "reactstrap";
import SwiperCore, { Autoplay } from "swiper";
import { useParams } from "react-router-dom";
import useSWR from "swr";

import { APIClient } from "../../utils/api_helper";
// import { profileSuccess } from "../../store/actions";
// import { useDispatch } from "react-redux";
import CountUp from "react-countup";

import profileBg from "../../assets/images/profile-bg.jpg";
import LoanModal from "./Modals/LoanModal";
import RepayLoanModal from "./Modals/RepayLoanModal";
import MsgToast from "../../Components/Common/MsgToast";

const api = new APIClient();

const transactionListFetcher = async (url) => {
  const { data } = await api.get(url);
  return data;
};

const UserInformation = () => {
  SwiperCore.use([Autoplay]);
  const { id } = useParams();

  let { data, error, isValidating } = useSWR(
    `/crowdfund/donation/${id || ""}/crowdfund-detail/`,
    transactionListFetcher,
    {
      revalidateOnFocus: false, // revalidate when the page gains focus
      revalidateOnReconnect: false, // revalidate when the browser regains network connectivity
    }
  );

  const { user } = useSelector((state) => ({
    user: state.Profile.user,
  }));
  const [openLoanModal, setOpenLoanModal] = useState(false);
  const [openRepayLoanModal, setOpenRepayLoanModal] = useState(false);
  const [copied, setCopied] = useState(false);

  console.log(data, "USER__LOANN_DATAA");

  let score_percentage = (data?.userCreditScore / 850) * 100;

  document.title = "Profile";

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(data?.link);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // reset after 2 seconds
    } catch (err) {
      console.error("Failed to copy!", err);
    }
  };

  return (
    <React.Fragment>
      <div className="profile-foreground position-relative mx-n4 mt-n4">
        <div className="profile-wid-bg">
          <img src={data?.image || profileBg} alt="" className="profile-wid-img" />
        </div>
      </div>
      <div className="pt-4 mb-4 mb-lg-3 pb-lg-4">
        <Row className="g-4">
          <Col lg={12}>
            <Row className="gx-lg-5">
              <Col xl={8} md={8} className="mx-auto">
                <Card>
                  <CardBody>
                    <div className="product-img-slider sticky-side-div">
                      <Card>
                        <CardBody>
                          <div className="d-flex align-items-center">
                            {/* <div className="avatar-sm flex-shrink-0">
                              <span className="avatar-title bg-light text-primary rounded-circle fs-3">
                                <i className={"align-middle  x-tabler-progress"}></i>
                              </span>
                            </div> */}
                            <div className="flex-grow-1 ms-3">
                              {/* <p className="text-uppercase fw-semibold fs-12 text-muted mb-3">
                                {" "}
                                {data?.userCreditScore} raised of 2000
                              </p> */}
                              <div className="progress animated-progress custom-progress progress-label ">
                                <div
                                  className="progress-bar bg-primary"
                                  role="progressbar"
                                  style={{ width: `${score_percentage}%` }}
                                  aria-valuenow="30"
                                  aria-valuemin="0"
                                  aria-valuemax="100"
                                >
                                  <div className="label bg-primary">
                                    {data?.current_amount} / {data?.target_amount}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                      <Card>
                        <CardBody>
                          <Row>
                            <Col xl={12} md={12}>
                              <Row className="d-flex align-items-center justify-content-between">
                                <Col xl={6} md={6} className="d-flex align-items-center">
                                  <div className="avatar-sm flex-shrink-0">
                                    <span className="avatar-title bg-light text-primary rounded-circle fs-3">
                                      <i className={"align-middle ri-money-dollar-circle-fill"}></i>
                                    </span>
                                  </div>

                                  <div>
                                    <p className="text-uppercase fw-semibold fs-6 text-muted mb-1">Amount raised</p>
                                    <h4 className=" mb-0">
                                      {" "}
                                      <CountUp
                                        className="fs-16"
                                        start={0}
                                        end={data?.current_amount}
                                        decimals={2}
                                        separator={","}
                                        prefix={user?.currency_symbol || ""}
                                        duration={3}
                                      />
                                    </h4>
                                  </div>
                                </Col>

                                <Col xl={6} md={6} className="d-flex align-items-center justify-content-end ">
                                  <div className="avatar-sm flex-shrink-0">
                                    <span className="avatar-title bg-light text-primary rounded-circle fs-3">
                                      <i className={"align-middle ri-money-dollar-circle-fill"}></i>
                                    </span>
                                  </div>

                                  <div>
                                    <p className="text-uppercase fw-semibold fs-6 text-muted mb-1">Target amount</p>
                                    <h4 className=" mb-0">
                                      {" "}
                                      <CountUp
                                        className="fs-16"
                                        start={0}
                                        end={data?.target_amount}
                                        decimals={2}
                                        separator={","}
                                        prefix={user?.currency_symbol || ""}
                                        duration={3}
                                      />
                                    </h4>
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </CardBody>

                        <p className="text-center">
                          <b> {data?.donor_count} </b> donors
                        </p>

                        <Button onClick={handleCopy} color="primary" className="btn-sm w-20">
                          <i className="ri-question-answer-line align-bottom me-1"></i> Share link
                        </Button>
                      </Card>
                    </div>
                  </CardBody>
                </Card>
              </Col>

              <Card>
                <CardBody>
                  <Col xl={12} md={12}>
                    <UncontrolledAlert color="primary" className="text-center">
                      {data?.title}
                    </UncontrolledAlert>
                  </Col>

                  <p>{data?.description}</p>
                </CardBody>
              </Card>
            </Row>
          </Col>
        </Row>
      </div>

      {copied ? <MsgToast msg={"Copied Link"} color="success" icon="ri-checkbox-circle-line" /> : null}

      <LoanModal openModal={openLoanModal} setOpenModal={setOpenLoanModal} link={data?.link} />
    </React.Fragment>
  );
};

export default UserInformation;
